export default function convertArrayToObject(array: any[]): {
  [id: string]: { name: string; created: number };
} {
  return array.reduce((obj, item) => {
    obj[item.id] = { name: item.name, created: item.created };
    return obj;
  }, {});
}
